import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  chakra,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, {
  Dispatch,
  MutableRefObject,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import EmailEditor from "react-email-editor";
import { template1 } from "./Templates";
import FormInput from "../../UI/form/FormInput";
import CustomModal from "../../UI/CustomModal";
import { sendSampleEmailCampaign } from "../../../API/campaign";
import { useMutation } from "@tanstack/react-query";
import { toaster } from "../../../utils/toast";
import { CreateCampaignProps } from "../../../atoms/campaigns";
export interface ExportedData {
  design: object;
  html: string;
}
interface EditTemplateProps {
  htmlContent: string;
  setHtmlContent: Dispatch<SetStateAction<string>>;
  emailEditorRef: MutableRefObject<any>;
  selectedTemplate: number | null;
  disclosure: any;
  currentStageData: any;
  setCurrentStageData: any;
}
interface Design {
  body: object;
}
const EditTemplate = ({
  htmlContent,
  setHtmlContent,
  emailEditorRef,
  selectedTemplate,
  disclosure,
  setCurrentStageData,
  currentStageData,
}: EditTemplateProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [templateBody, setTemplateBody] = useState("");

  

  const toast = useToast();
  

  const { mutate, isLoading } = useMutation(sendSampleEmailCampaign, {
    onSuccess(data) {
      const success = { ...data };
      toaster(toast, success);
    
    
    },

    onError(data: any) {
      const errors = { ...data };
      toaster(toast, errors);
    },
  });

  const exportHtml = () => {
    emailEditorRef.current.editor.exportHtml((data: any) => {
      const { design, html } = data;
      console.log("exportHtml", html);
      const templateDesign = JSON.stringify(design);
      setCurrentStageData((prevData:CreateCampaignProps) => {
        return {
          ...prevData,
          data: {
            ...prevData?.data,
            builder_content: templateDesign,
            message_body: html,
          },
        };
      });
      setTemplateBody(html);
      console.log("design", design);
    });
  };

  const exportAndPreview = () => {
    emailEditorRef.current?.editor.exportHtml((data: ExportedData) => {
      const { html } = data;
      setHtmlContent(html);
      //   console.log(html);
      onOpen();
    });
    emailEditorRef.current?.editor.saveDesign((design: Design) => {
      console.log("Design saved:", design);
      // Optionally, send the design to a server or store it in a database
    });
  };

  const onLoad = () => {
    if (currentStageData?.data?.builder_content){
      const design = JSON.parse(currentStageData?.data?.builder_content);
      emailEditorRef?.current?.editor?.loadDesign(design);
    } else if (currentStageData?.data?.template_uid === "blank") {
      emailEditorRef?.current?.editor?.loadDesign(template1);
    } else {
      emailEditorRef?.current?.editor?.loadDesign(currentStageData?.data?.message_body)
    }
  };

  return (
    <Box minHeight={"100vh"}>
      <Box display={"flex"} justifyContent={"end"} my={"2"}>
        <Box display={"flex"} justifyContent={"space-between"} width={"full"}>
          <Box>
            <Text fontWeight={700} fontSize={20}>
              Edit Template
            </Text>
            <Text color={"#7489AA"} fontSize={12} fontWeight={500}>
              Create Your Campaign Mail Here
            </Text>
          </Box>
          <Box>
            <Button
              mx={"2"}
              border={"3px solid #0066FF"}
              color={"#0066FF"}
              bg={"white"} 
              rounded={"none"}
              onClick={()=>{
                mutate({message_body: templateBody})
              }}
              isLoading={isLoading}
              isDisabled={!templateBody}
            >
              Send Test Mail
            </Button>
            <CustomModal
              disclosure={disclosure}
              title={
                <Text fontSize={"20px"} color="grays.8" mt="35px" pr="38px">
                  Send a sample mail
                </Text>
              }
            >
              {/* {currentStage === 'entry' && ( */}
              <chakra.form
                onSubmit={(e) => {
                  e.preventDefault();

                  //   mutate({
                  //     amount,
                  //     currency: 'NGN',
                  //   });
                }}
              >
                <Box
                  borderBottomWidth={"1px"}
                  h={"0.1px"}
                  borderColor={"borders.100"}
                ></Box>
                <FormInput
                  label="Enter one or more recipients"
                  type="email"
                  for="amount"
                  formControlProps={{
                    mt: "32px",
                  }}
                  inputProps={{
                    placeholder: "test@hostmail.com, test2@hostmail.com",
                    onChange: (e) => {
                      e.preventDefault();
                      setCurrentStageData((prevData: any) => {
                        return {
                          ...prevData,
                          data: {
                            ...prevData?.data,
                            email: e.target.value,
                          },
                        };
                      });
                    },
                    autoFocus: true,
                  }}
                />
                <Text
                  fontSize={"14px"}
                  fontWeight={700}
                  color="grays.8"
                  mt="5px"
                >
                  Use commas to seperate multiple emails
                </Text>
                <Button
                  // isLoading={isLoading || getLowestLoading}
                  isDisabled={!currentStageData?.data?.email}
                  w="full"
                  colorScheme={"primary"}
                  mt="32px"
                  mb="40px"
                  type="submit"
                  onClick={disclosure.onClose}
                >
                  Send sample
                </Button>
              </chakra.form>
            </CustomModal>
            <Button
              mx={"2"}
              rounded={"none"}
              bg={"#0066FF"}
              color={"white"}
              colorScheme="primary"
              onClick={exportHtml}
            >
              Save Changes
            </Button>
            <Modal isOpen={isOpen} onClose={onClose} size="xl">
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>Email Template Preview</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <iframe
                    title="Email Preview"
                    srcDoc={htmlContent}
                    width="100%"
                    height="500px"
                    style={{ border: "none" }}
                  />
                </ModalBody>
              </ModalContent>
            </Modal>
          </Box>
        </Box>
      </Box>
      <Box
        bg={"#0066FF"}
        width={"100%"}
        height={"50px"}
        textAlign={"center"}
        color={"white"}
        p={2}
      >
        <Text fontSize={"16px"} fontWeight={500}>
          To add an attribute to your mail , follow the format
          &#10100;&#10100;attribute&#10101;&#10101; example to add first name
          &#10100;&#10100;first_name&#10101;&#10101;, last name
          &#10100;&#10100;.last_name&#10101;&#10101;{" "}
        </Text>
      </Box>
      <EmailEditor
        // onReady={onReady}
        onLoad={onLoad}
        ref={emailEditorRef}
        minHeight={"100vh"}
        options={{
          appearance: {
            panels: {
              tools: {
                dock: "left",
              },
            },
          },
        }}
      />
      <Box my={"2"} display={"flex"} justifyContent={"end"} pr={"10"}>
        <Button
          mx={"2"}
          bg={"#0066FF"}
          color={"white"}
          colorScheme="primary"
          isDisabled={!templateBody}
          onClick={() => {
            setCurrentStageData((prevData: any) => {
              return {
                ...prevData,
                currentStage: "Recipients",
                data: {
                  ...prevData?.data,
                  message_body: templateBody,
                },
              };
            });
            console.log(templateBody);
          }}
        >
          {templateBody ? "Continue to Recipients" : "Save changes to continue"}
        </Button>
      </Box>
    </Box>
  );
};

export default EditTemplate;
